// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0705b822","453":"8076ffb4","455":"a605c2b7","977":"3b253bd2"}[chunkId] + ".chunk.js";
};